import { render } from "./invisionBoolean.vue?vue&type=template&id=2003b2b8"
import script from "./invisionBoolean.vue?vue&type=script&lang=js"
export * from "./invisionBoolean.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__